export default {
	TYPE_MARKED_AS_SEND: 0,
	TYPE_SEND_EMAIL: 1,
	TYPE_SEND_REMINDER: 2
};
